import { trackByEvent } from "@src/tracking/services"
import { COURIER_CARD_TRACKING_EVENTS, COURIER_ORDER_SHOW_HIDE_EVENTS, COURIER_SETTINGS_TRACKING_EVENTS, COURIER_TRACKING_EVENTS, TCourierAdd, TCourierCardClick, TCourierCardLoad, TSettingsOpen, TToggleOn } from "."
import { COMPONENT_TYPE } from "@src/tracking/constant"

const trackManageCouriersActiveCourierList = (
    countsTotal:number,
    language:string,
    country:string
) => {
    try {
       return trackByEvent<TCourierCardLoad>(COURIER_CARD_TRACKING_EVENTS.ACTIVE_COURIERS.event,{
        eventCategory: '',
        component_name: COURIER_CARD_TRACKING_EVENTS.ACTIVE_COURIERS.component_name,
        component_type: COURIER_CARD_TRACKING_EVENTS.ACTIVE_COURIERS.component_type as COMPONENT_TYPE,
        list_action: COURIER_CARD_TRACKING_EVENTS.ACTIVE_COURIERS.list_action,
        list_countsTotal: countsTotal,
        country,
        language
       })

    } catch (error) {
        console.log(error)
    }
}

const trackManageCouriersPendingCourierList = (
    countsTotal:number,
    language:string,
    country:string
) => {
    try {
       return trackByEvent<TCourierCardLoad>(COURIER_CARD_TRACKING_EVENTS.PENDING_COURIERS.event,{
        eventCategory: '',
        component_name: COURIER_CARD_TRACKING_EVENTS.PENDING_COURIERS.component_name,
        component_type: COURIER_CARD_TRACKING_EVENTS.PENDING_COURIERS.component_type as COMPONENT_TYPE,
        list_action: COURIER_CARD_TRACKING_EVENTS.PENDING_COURIERS.list_action,
        list_countsTotal: countsTotal,
        country,
        language
       })

    } catch (error) {
        console.log(error)
    }
}

const trackManageCouriersActiveCourierCardClick = (
    country:string,
    language:string,
    courierDetail:string,
) => {
    try {
        return trackByEvent<TCourierCardClick>(COURIER_CARD_TRACKING_EVENTS.ACTIVE_COURIERS_CLICK.event,{
            eventCategory: '',
            component_name: COURIER_CARD_TRACKING_EVENTS.ACTIVE_COURIERS_CLICK.component_name,
            component_type: COURIER_CARD_TRACKING_EVENTS.ACTIVE_COURIERS_CLICK.component_type as COMPONENT_TYPE,
            courierDetail,
            country,
            language
        })
    } catch (error) {
        console.log(error)
    }
}

const trackManageCouriersPendingCourierCardClick = (
    country:string,
    language: string,
    courierDetail:string
) => {
    try {
        return trackByEvent<TCourierCardClick>(COURIER_CARD_TRACKING_EVENTS.PENDING_COURIERS_CLICK.event,{
            eventCategory: '',
            component_name: COURIER_CARD_TRACKING_EVENTS.PENDING_COURIERS_CLICK.component_name,
            component_type: COURIER_CARD_TRACKING_EVENTS.PENDING_COURIERS_CLICK.component_type as COMPONENT_TYPE,
            courierDetail,
            country,
            language
        })
    } catch (error) {
        console.log(error)
    }
}

const trackManagerCourierAddInputError = (
    country:string,
    language: string,
    courierDetail:string
) => {
    try {
        return trackByEvent<TCourierAdd>(COURIER_TRACKING_EVENTS.COURIER_INVITATION_ADD_ERROR.event,{
            eventCategory: '',
            component_name: COURIER_TRACKING_EVENTS.COMPONENT_NAME,
            component_type: COURIER_TRACKING_EVENTS.COURIER_INVITATION_ADD_ERROR.component_type as COMPONENT_TYPE,
            courierDetail,
            country,
            language
        })
    } catch (error) {
        console.log(error)
    }
}

const trackManageCourierOnSettingsClick = (
    country:string,
    language:string
) => {
    try {
        return trackByEvent<TSettingsOpen>(COURIER_SETTINGS_TRACKING_EVENTS.SETTINGS_OPEN.event,{
            eventCategory: '',
            component_name: COURIER_SETTINGS_TRACKING_EVENTS.SETTINGS_OPEN.component_name,
            component_type: COURIER_SETTINGS_TRACKING_EVENTS.SETTINGS_OPEN.component_type as COMPONENT_TYPE,
            country,
            language
        })
    } catch (error) {
        console.log(error)
    }
}

const trackManageCourierTipsToggleOn = (
    country: string,
    language: string
) => {
    try {
        return trackByEvent<TToggleOn>(COURIER_SETTINGS_TRACKING_EVENTS.TOGGLE_ON.event,{
            eventCategory: '',
            component_name: COURIER_SETTINGS_TRACKING_EVENTS.TOGGLE_ON.component_name,
            component_type: COURIER_SETTINGS_TRACKING_EVENTS.TOGGLE_ON.component_type as COMPONENT_TYPE,
            country,
            language
        })
    } catch (error) {
        console.log(error)
    }
}

const trackManageCourierTipsToggleOff = (
    country: string,
    language: string
) => {
    try {
        return trackByEvent<TToggleOn>(COURIER_SETTINGS_TRACKING_EVENTS.TOGGLE_OFF.event,{
            eventCategory: '',
            component_name: COURIER_SETTINGS_TRACKING_EVENTS.TOGGLE_OFF.component_name,
            component_type: COURIER_SETTINGS_TRACKING_EVENTS.TOGGLE_OFF.component_type as COMPONENT_TYPE,
            country,
            language
        })
    } catch (error) {
        console.log(error)
    }
}

const trackManageCourierShowHideOrderOnCardClick = (
    country:string,
    language:string
) => {
    try {
        return trackByEvent<TSettingsOpen>(COURIER_ORDER_SHOW_HIDE_EVENTS.SETTINGS_OPEN.event,{
            eventCategory: '',
            component_name: COURIER_ORDER_SHOW_HIDE_EVENTS.SETTINGS_OPEN.component_name,
            component_type: COURIER_ORDER_SHOW_HIDE_EVENTS.SETTINGS_OPEN.component_type as COMPONENT_TYPE,
            country,
            language
        })
    } catch (error) {
        console.log(error)
    }
}

const trackManageCourierShowHideOrderToggleOn = (
    country: string,
    language: string
) => {
    try {
        return trackByEvent<TToggleOn>(COURIER_ORDER_SHOW_HIDE_EVENTS.TOGGLE_ON.event,{
            eventCategory: '',
            component_name: COURIER_ORDER_SHOW_HIDE_EVENTS.TOGGLE_ON.component_name,
            component_type: COURIER_ORDER_SHOW_HIDE_EVENTS.TOGGLE_ON.component_type as COMPONENT_TYPE,
            country,
            language
        })
    } catch (error) {
        console.log(error)
    }
}

const trackManageCourierShowHideOrderToggleOff = (
    country: string,
    language: string
) => {
    try {
        return trackByEvent<TToggleOn>(COURIER_ORDER_SHOW_HIDE_EVENTS.TOGGLE_OFF.event,{
            eventCategory: '',
            component_name: COURIER_ORDER_SHOW_HIDE_EVENTS.TOGGLE_OFF.component_name,
            component_type: COURIER_ORDER_SHOW_HIDE_EVENTS.TOGGLE_OFF.component_type as COMPONENT_TYPE,
            country,
            language
        })
    } catch (error) {
        console.log(error)
    }
}


export {
    trackManageCouriersActiveCourierList,
    trackManageCouriersPendingCourierList,
    trackManageCouriersActiveCourierCardClick,
    trackManageCouriersPendingCourierCardClick,
    trackManagerCourierAddInputError,
    trackManageCourierOnSettingsClick,
    trackManageCourierTipsToggleOn,
    trackManageCourierTipsToggleOff,
    trackManageCourierShowHideOrderToggleOn,
    trackManageCourierShowHideOrderToggleOff,
    trackManageCourierShowHideOrderOnCardClick
}